var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.username)?_c('router-link',{staticClass:"menu-profile-item",attrs:{"to":{ name: _vm.name, params: { username: _vm.username }}}},[(_vm.hasIcon)?_c('user-icon',{staticClass:"header-menuitem-icon",attrs:{"size":"1x"}}):_vm._e(),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }